import { Edit, FiberNew, NewReleases, WarningOutlined } from "@mui/icons-material";

import schema from "./schema";

import Tablizo from "Components/LabIZO/Tablizo";
import _ from "lodash";

const tabs = [
  {
    label: (data) => "Warnings (" + ((data.warn && data.warn.length) || 0) + ")",
    icon: <WarningOutlined />,
    render: (data) => <Tablizo width="100%" height="100%" schema={schema.Warnings} data={data.warn || []} rowIdAccessor="id" density="compact" showSelector={false} />,
  },
  {
    label: (data) => "New FAQs (" + ((data.newData && data.newData.length) || 0) + ")",
    icon: <FiberNew />,
    render: (data) => <Tablizo width="100%" height="100%" schema={schema.New} data={data.newData || []} rowIdAccessor="id" density="compact" showSelector={false} />,
  },
  {
    label: (data) => {
      const updatedData = (data?.updateData || []).filter((faq) => faq.intent || (faq.answer && !_.isEmpty(faq.answer)) || faq.quickReply);
      return "Update FAQs (" + updatedData.length + ")";
    },
    icon: <Edit />,
    render: (data) => {
      const updatedData = (data?.updateData || []).filter((faq) => faq.intent || (faq.answer && !_.isEmpty(faq.answer)) || faq.quickReply);
      return <Tablizo width="100%" height="100%" schema={schema.Update} data={updatedData} rowIdAccessor="id" density="compact" showSelector={false} />;
    },
  },
  {
    label: (data) => {
      const updatedExpiredData = (data?.updateData || []).filter((faq) => (faq.expiriable && !_.isEmpty(faq.expiriable)) || faq.quickReplyPromo);
      return "Update FAQs (Expired) (" + updatedExpiredData.length + ")";
    },
    icon: <Edit />,
    render: (data) => {
      const updatedExpiredData = (data?.updateData || []).filter((faq) => (faq.expiriable && !_.isEmpty(faq.expiriable)) || faq.quickReplyPromo);
      return <Tablizo width="100%" height="100%" schema={schema.UpdateExpire} data={updatedExpiredData} rowIdAccessor="id" density="compact" showSelector={false} />;
    },
  },
  {
    label: (data) => "Errors (" + ((data.error && data.error.length) || 0) + ")",
    icon: <NewReleases />,
    render: (data) => <Tablizo width="100%" height="100%" schema={schema.Errors} data={data.error || []} rowIdAccessor="id" density="compact" showSelector={false} />,
  },
];

export default tabs;
